import { createContext, useContext } from 'react';
export var defaultEmbedContextValue = {
  dispatch: function dispatch() {
    return null;
  },
  boardContainerConfig: {},
  boardContainerState: {
    editableTemplates: {
      isEditableTemplatesExperiment: false,
      isEditableTemplateBoardActive: false,
      editableTemplatePreview: {},
      templateKey: ''
    }
  },
  iframeConfig: {},
  iframeState: {},
  boardState: {}
};
export var EmbedContext = /*#__PURE__*/createContext(defaultEmbedContextValue);
export var usePreproductPreviewContext = function usePreproductPreviewContext() {
  var context = useContext(EmbedContext);
  return context;
};